module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("“I have called you back from the ends of the earth so you can serve me. For I have chosen you and will not throw you away. Don’t be afraid, for I am with you. Do not be dismayed, for I am your God. I will strengthen you. I will help you. I will uphold you with my victorious right hand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_vm._v("Isaiah 41: 9-10")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_vm._v("And so it was with the Coast Guard in "), _c('br'), _vm._v("New Orleans, in September of 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "x-1-chapter-number"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f694276","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Verse.vue
// module id = 69
// module chunks = 0